import { useState } from 'react';
import { TaskDetailsPanel } from '../Tasks.Details';
import { Modal } from 'antd';

export function useEditTaskCommentsAction() {
  const [id, setId] = useState<string>();

  return {
    openEdit: (id: string) => setId(id),
    editModal: (
      <>
        {id && (
          <Modal
            visible
            onCancel={() => setId(undefined)}
            onOk={() => setId(undefined)}
            width="70%"
          >
            <TaskDetailsPanel taskId={id} isModal />
          </Modal>
        )}
      </>
    ),
  };
}
